import {each} from 'underscore';
import xhr from './Xhr';
import querySelectorAll from './querySelectorAll';
import {addRenderEventListener} from './RequestPasswordSubscriber';

function findAncestor(element, className) {
    let currentElement = element;

    while (!currentElement.classList.contains(className)) {
        currentElement = currentElement.parentElement;
    }

    return currentElement;
}

export default class LoginFormSubscriber {
    constructor() {
        this.CLASSES = {
            form_wrapper: 'js-login-form-wrapper',
            trigger: {
                submit: 'js-login-subscriber'
            }
        };

        this.INPUTNAMES = {
            _username: '_username',
            _password: '_password',
            _token: '_token'
        };

        this.addLoginEventListener();
    }

    addLoginEventListener() {
        each(document.querySelectorAll(`.${this.CLASSES.trigger.submit}`),
            (el) => {
                el.addEventListener('submit',
                    (event) => this.submitForm(event));
            });
    }

    submitForm(event) {
        event.preventDefault();

        const checkbox = event.target;
        const form = checkbox.closest('form');
        const modal = findAncestor(form, 'modal');
        const location = modal.dataset.location;
        const url = form.getAttribute('action');

        if (url) {
            // Build data params
            let data = '';
            each(this.INPUTNAMES, (inputField) => {
                const el = form.querySelector(`[name="${inputField}"]`);
                if (el === null) {
                    return;
                }

                let value;

                if (el.type === 'checkbox') {
                    if (el.checked) {
                        value = el.checked;
                    }
                } else {
                    value = form.querySelector(`[name="${inputField}"]`).value;
                }
                if (value) {
                    data += `${inputField}=${value}&`;
                }
            });

            xhr.post(url, data).then((request) => {
                // Check if we have a json response, if not reload current page.
                try {
                    const response = JSON.parse(request.responseText);

                    const wrapper = document.querySelectorAll(`.${this.CLASSES.form_wrapper}`)[0];

                    if (typeof wrapper !== 'undefined') {
                        // Create invisible container;
                        const tempContainerId = 'temp-container';
                        const tempContainer = document.createElement('div');
                        tempContainer.id = tempContainerId;
                        tempContainer.style.setProperty('display', 'none');
                        document.body.appendChild(tempContainer);

                        // Append items into invisible container;
                        tempContainer.insertAdjacentHTML('beforeend', response.output);

                        const node = querySelectorAll(`#${tempContainerId} .${this.CLASSES.form_wrapper}`)[0];
                        wrapper.innerHTML = node.innerHTML;
                        document.body.removeChild(tempContainer);

                        addRenderEventListener();
                    }
                } catch (e) {
                    if (location !== undefined) {
                        window.location = location;
                    } else {
                        window.location = document.URL;
                    }
                    return;
                }

                this.reloadEventListeners();
            });
        }
    }

    reloadEventListeners() {
        this.addLoginEventListener();
    }
}



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/LoginFormSubscriber.js